export const Footer = () => {

    const Developer = () => {
        const DevCont = 'https://instagram.com/bilobrov_official?igshid=NTc4MTIwNjQ2YQ==';
        window.open(DevCont);
    }

    const MapLink = () => {
       const Map = 'https://goo.gl/maps/A9G7JSDbUdGFytit9';
       window.open(Map);
         
    }

    return (
        <footer id="footer">
            <div className="footer-m-bl" id="Contact">
                <div className="footer-side-bl side-one">
                <h2>Barber Malek</h2>
                    <div className="style-bl-cont">
                        <p><span>Contact:</span> +1 (519) 751 95 14</p>
                        <p onClick={MapLink}><span>Addres:</span> 210 West St 210 West St, Brantford, ON N3R 3T9, Brantford, ON, Canada, Ontario</p>
                        <p id="pd"><span>Working Hours:</span></p>
                        <ul>
                            <li><strong>Sat:</strong> 09:30-19:00</li>
                            <li><strong>Sun:</strong> 09:30-16:00</li>
                            <li><strong>Mon:</strong> Closed</li>
                            <li><strong>Tue - Fri:</strong> 09:30-19:00</li>
                        </ul>
                    </div>
                    
                </div>

                <div className="footer-side-bl side-two"></div>
            </div>
            <div className="rights-bl" onClick={Developer}><p>© 2023 All rights Reserved. Designed by Bilobrov Filip</p></div>
        </footer>
    );
}